<template>
  <div class="embudo-ventas">
    <h3 class="text-2xl font-bold text-gray-800 mb-6">📊 Embudo Completo del Negocio</h3>
    
    <!-- Embudo Visual -->
    <div class="mb-8">
      <div class="space-y-4">
        <div
          v-for="(etapa, index) in embudo"
          :key="index"
          class="relative"
        >
          <div
            :style="{
              width: etapa.porcentaje + '%',
              backgroundColor: etapa.color,
              marginLeft: ((100 - etapa.porcentaje) / 2) + '%'
            }"
            class="rounded-2xl shadow-lg p-6 text-white transform hover:scale-105 transition-all duration-300 cursor-pointer"
          >
            <div class="flex items-center justify-between">
              <div>
                <div class="text-sm font-semibold opacity-90 mb-1">{{ etapa.nombre }}</div>
                <div class="text-3xl font-black">{{ etapa.cantidad }}</div>
              </div>
              <div class="text-right">
                <div class="text-2xl font-bold">{{ etapa.porcentaje }}%</div>
                <div class="text-sm opacity-90">del total</div>
              </div>
            </div>
          </div>
          
          <!-- Flecha de conexión -->
          <div v-if="index < embudo.length - 1" class="flex justify-center my-2">
            <svg class="w-8 h-8 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M10 3a1 1 0 011 1v10.586l2.293-2.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 14.586V4a1 1 0 011-1z" clip-rule="evenodd" />
            </svg>
          </div>
        </div>
      </div>
    </div>

    <!-- Tasas de Conversión -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
      <div class="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl p-6 border border-blue-100">
        <h4 class="text-lg font-bold text-gray-800 mb-4">📈 Tasas de Conversión</h4>
        <div class="space-y-3">
          <div v-for="(tasa, key) in tasasConversion" :key="key">
            <div class="flex justify-between items-center mb-1">
              <span class="text-sm font-medium text-gray-700">{{ formatKey(key) }}</span>
              <span class="text-lg font-bold text-blue-600">{{ tasa }}%</span>
            </div>
            <div class="w-full bg-gray-200 rounded-full h-2">
              <div
                :style="{ width: tasa + '%' }"
                class="bg-gradient-to-r from-blue-500 to-indigo-500 h-2 rounded-full transition-all duration-500"
              ></div>
            </div>
          </div>
        </div>
      </div>

      <div class="bg-gradient-to-br from-red-50 to-pink-50 rounded-2xl p-6 border border-red-100">
        <h4 class="text-lg font-bold text-gray-800 mb-4">🚨 Cuellos de Botella</h4>
        <div class="space-y-4">
          <div
            v-for="(cuello, index) in cuellos"
            :key="index"
            :class="[
              'p-4 rounded-xl border-l-4',
              cuello.severidad === 'ALTA' ? 'bg-red-100 border-red-500' : 'bg-yellow-100 border-yellow-500'
            ]"
          >
            <div class="flex justify-between items-start mb-2">
              <span class="font-semibold text-gray-800">{{ cuello.etapa }}</span>
              <span :class="[
                'px-2 py-1 rounded-full text-xs font-bold',
                cuello.severidad === 'ALTA' ? 'bg-red-200 text-red-800' : 'bg-yellow-200 text-yellow-800'
              ]">
                {{ cuello.severidad }}
              </span>
            </div>
            <div class="text-2xl font-bold text-gray-900 mb-1">{{ cuello.cantidad_perdida }}</div>
            <div class="text-sm text-gray-600">{{ cuello.porcentaje_perdida }}% de pérdida</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Recomendaciones -->
    <div class="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-6 border border-green-100">
      <h4 class="text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">
        💡 Recomendaciones para Mejorar el Flujo
      </h4>
      <ul class="space-y-2">
        <li
          v-for="(rec, index) in recomendaciones"
          :key="index"
          class="flex items-start gap-3 text-gray-700"
        >
          <span class="text-green-600 font-bold">✓</span>
          <span>{{ rec }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmbudoVentas',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    embudo() {
      return this.data?.embudo_visual || []
    },
    tasasConversion() {
      return this.data?.tasas_conversion || {}
    },
    cuellos() {
      return this.data?.cuellos_botella || []
    },
    recomendaciones() {
      return this.data?.recomendaciones_flujo || []
    }
  },
  methods: {
    formatKey(key) {
      return key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
    }
  }
}
</script>
